<template>
  <v-form ref="form" v-model="isValid" @submit.prevent="createOrg">

    <error-dialog :status="loadAccountStatus" />
    <error-dialog :status="createOrgStatus" />

    <sign-in-dialog v-model="showSignIn">
      <template v-slot:subtitle>Sign in to verify your email address</template>
    </sign-in-dialog>

    <v-text-field
      :value="isSignedIn ? global.profile.email : null"
      name="Email address" label="Email address" readonly
      :error-messages="accountErr"
      @click="showSignIn = true"
    >
      <template v-slot:append-outer>
        <v-btn
          small
          :loading="loadAccountStatus.pending"
          @click="showSignIn = true"
          v-text="isSignedIn ? 'Change…' : 'Sign in…'"
        />
      </template>
    </v-text-field>
    <v-text-field
      class="mt-6"
      outlined dense name="your name" label="Your name"
      :disabled="isDisabled"
      v-model="customerName"
    />
    <v-text-field
      outlined dense name="Organization name" label="Organization name"
      :disabled="isDisabled"
      :rules="[ v => !!v || 'Required' ]"
      v-model="orgName"
    />
    <v-textarea
      hide-details outlined label="Please describe your use case" auto-grow
      :disabled="isDisabled"
      v-model="notes"
    />
    <div class="mt-1 text--label-active">Ellacard has powerful tools to support your use case – we'll point you in the right direction to help you get started</div>

    <div class="mt-6 d-flex">
      <v-spacer />
      <v-btn v-if="!hideCancel" class="mr-4" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn
        color="primary"
        :disabled="isDisabled"
        :loading="createOrgStatus.pending"
        @click="$refs.form.validate() && createOrg()"
      >
        Submit
      </v-btn>
    </div>
  </v-form>
</template>


<script>
import ErrorDialog from '@/components/ErrorDialog.vue';
import SignInDialog from '@/components/SignInDialog.vue';


export default {
  name: 'org-sign-up-form',

  components: {
    ErrorDialog,
    SignInDialog
  },

  props: {
    hideCancel: Boolean
  },

  data() {
    return {
      account: null,
      showSignIn: false,
      customerName: null,
      orgName: null,
      notes: null,
      isValid: false,
      loadAccountStatus: this.$track('loadAccount'),
      createOrgStatus: this.$track('createOrg')
    };
  },

  computed: {
    accountErr() {
      if (!this.isSignedIn)
        return 'Sign in to verify your email address';
      if (this.global.profile.org)
        return 'This account already belongs to an organization';
      if ((this.account?.subscription?.metadata.code == 'SINGLE-USER') && this.account?.subscription.next_at)
        // Note that this also catches the case where a user has signed up for but cancelled their single-user
        // subscription
        return 'Access to org tools is not allowed with a SINGLE-USER subscription';
      return null;
    },

    isDisabled() {
      return !!this.accountErr || this.loadAccountStatus.pending;
    }
  },

  methods: {
    async loadAccount() {
      this.account = await this.$call('get-account');
    },

    async createOrg() {
      if (this.isDisabled)
        return;

      const params = {
        customer_name: this.customerName,
        org_name: this.orgName,
        plan: this.fixedPlan || this.plan,
        notes: this.notes,
        referral_code: this.referralCode,
        url: location.href
      };
      await this.$call('/create-org', params);
      await this.$refreshJWT();
      this.$emit('complete');
    }
  },

  watch: {
    globalUserId: {
      immediate: true,
      handler(v) {
        this.account = null;
        v && this.loadAccount();
      }
    }
  }
}
</script>
